<template>
  <div>
    <el-menu
      :default-active="activeIndex"
      mode="horizontal"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#409EFF"
      :router="true"
    >
      <div style="height: 50px; display: flex; align-items: center; width: 90%; justify-content: flex-start">
        <template v-for="route in routes" :key="route.path">
          <div v-if="!route.hidden">
            <template v-if="hasOneShowingChild(route.children, route)">
              <el-menu-item style="text-align: center" :index="resolvePath(route.path)">
                <svg-icon style="font-size: 15px" :icon-class="route.children[0].meta.icon" />
                &nbsp;<span style="font-size: 12px">{{ route.children[0].meta.title }}</span>
              </el-menu-item>
            </template>

            <el-sub-menu v-else-if="route.meta" style="text-align: center" :index="resolvePath(route.path)">
              <template #title>
                <svg-icon style="font-size: 15px; margin-left: 0px" :icon-class="route.meta.icon" />
                &nbsp;<span style="font-size: 12px">{{ route.meta.title }}</span>
              </template>
              <el-menu-item
                v-for="child in route.children"
                :key="child.path"
                style="text-align: left"
                :index="resolvePath(child.path)"
              >
                <svg-icon style="font-size: 15px" :icon-class="(child.meta && child.meta.icon) || ''" />
                &nbsp;<span style="font-size: 12px">{{ child.meta.title }}</span>
              </el-menu-item>
            </el-sub-menu>
          </div>
        </template>
      </div>
    </el-menu>
  </div>
</template>

<script>
import { isExternal } from '@/utils/validate';
import path from 'path';

export default {
  data() {
    return {
      activeIndex: null,
      // span: 0,
    };
  },
  computed: {
    routes() {
      return this.$router.options.routes;
    },
    /*
    mode: {
      get() {
        return this.$store.state.user.mode;
      },
    },
    */
  },
  watch: {
    $route(to) {
      /*
      if (this.mode === 1) {
        this.activeIndex = to.path === '/' ? '/SystemNetwork' : to.path;
      } else {
        this.activeIndex = to.path;
      }
      */
      this.activeIndex = to.path;
    },
    routes: {
      immediate: true,
      handler(val) {
        for (const route of this.routes) {
          if (
            // route.path === '/UserManagement' ||
            // route.path === '/SubGConfig' ||
            // route.path === '/Dashboard' ||
            // route.path === '/SystemInfo' ||
            route.path === '/'
          ) {
            route.span = 3;
          } else {
            route.span = 2;
          }
        }
      },
    },
  },
  mounted() {
    // this.span = Math.floor(24 / (this.routes.length - 2));
    /*
    if (this.mode === 1) {
      this.activeIndex =
        this.resolvePath('/' + window.location.href.split('/')[4]) === '/'
          ? '/SystemNetwork'
          : this.resolvePath('/' + window.location.href.split('/')[4]);
    } else {
      this.activeIndex = this.resolvePath('/' + window.location.href.split('/')[4]);
    }
    */
    this.activeIndex = this.resolvePath('/' + window.location.href.split('/')[4]);
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter((route) => {
        if (route.hidden) {
          return false;
        } else {
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        return true;
      }

      return false;
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      return path.resolve(routePath, routePath);
    },
  },
};
</script>

<style>
#app
  > div
  > div
  > div
  > div
  > div.el-row
  > div.el-col.el-col-19
  > div
  > ul
  > div
  > div:nth-child(6)
  > span
  > li
  > div
  > i {
  right: 0px;
}

.el-sub-menu__icon-arrow {
  right: 5px;
}
</style>
